import React from "react";

// The "what has already happened on this property" list. Used for the property
// being renamed (informational) and for each property that would be deleted,
// where the same list is the reason to think twice.
export default function StateChecklist({ state = [], tone = "neutral" }) {
  const doneClass =
    tone === "danger"
      ? "bg-red-600 text-white border-red-600"
      : "bg-black text-white border-black";

  return (
    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
      {state.map((s) => (
        <li
          key={s.key}
          className={`flex items-center justify-between gap-3 rounded border px-3 py-2 ${
            s.done ? doneClass : "bg-white border-mediumgray"
          }`}
        >
          <span
            className={`text-sm font-medium ${s.done ? "" : "text-darkgray"}`}
          >
            {s.label}
          </span>
          <span
            className={`text-xs text-right shrink-0 ${
              s.done ? "opacity-90" : "text-darkgray"
            }`}
          >
            {s.done ? s.detail || "Done" : "Not done"}
          </span>
        </li>
      ))}
    </ul>
  );
}
